import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <header className="n1-header">
      <div className="header-container">
        <Link to="/" className="logo-link">
          <img 
            src="https://eu2007.de/?attachment_id=18472" 
            alt="N1 Casino Logo" 
            className="n1-logo"
            onError={(e) => {
              e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="120" height="40" viewBox="0 0 120 40"%3E%3Ctext x="10" y="30" font-family="Arial" font-size="28" font-weight="bold" fill="%23DC0000"%3EN1%3C/text%3E%3C/svg%3E';
            }}
          />
        </Link>

        <nav className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          <Link 
            to="/" 
            className={`nav-link ${isActive('/') ? 'active' : ''}`}
            onClick={() => setIsMenuOpen(false)}
          >
            N1 Casino
          </Link>
          <Link 
            to="/sportwetten" 
            className={`nav-link ${isActive('/sportwetten') ? 'active' : ''}`}
            onClick={() => setIsMenuOpen(false)}
          >
            N1 Bet
          </Link>
        </nav>

        <div className="header-actions">
          <button className="btn-login">Einloggen</button>
          <button className="btn-register">Registrieren</button>
        </div>

        <button className="mobile-menu-toggle" onClick={toggleMenu}>
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
    </header>
  );
};

export default Header;
